export default {"src":"https://fishbrain.com/_next/static/media/newHampshire.9a28e75d.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};